import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const Tracker = () => {
  const location = useLocation();
  const startTimeRef = useRef<number>(Date.now());
  const pathRef = useRef<string>(location.pathname);

  const sendTracking = () => {
    const endTime = Date.now();
    const scrollDepth = document.documentElement.scrollHeight - window.innerHeight > 0
      ? window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)
      : 0;

    const trackingData = {
      path: pathRef.current,
      startTime: startTimeRef.current,
      endTime,
      duration: endTime - startTimeRef.current,
      scrollDepth: Math.min(Math.max(scrollDepth, 0), 1),
    };

    // sendBeacon 대신 fetch 사용 가능, sendBeacon은 페이지 언로드 전용
    navigator.sendBeacon('https://api.avviopage.com/api/v1/landing/track', new Blob([JSON.stringify(trackingData)], { type: 'text/plain' }));
  };

  useEffect(() => {
    // SPA 페이지 이동 시 startTime 갱신
    startTimeRef.current = Date.now();
    pathRef.current = location.pathname;

    // 페이지 진입 즉시 전송
    sendTracking();

    // heartbeat: 5초마다 체류 시간 업데이트
    const interval = setInterval(sendTracking, 5000);

    // visibilitychange: 앱 백그라운드/포커스 전환 감지
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        sendTracking();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      // 페이지 떠날 때 최종 전송
      sendTracking();
    };
  }, [location.pathname]);

  return null;
};

export default Tracker;
